import classNames from 'classnames';
import React from 'react'
import { truncate } from 'utils/common'

const CountRenderer = ({ color, onClick, column, prefix, gridView, def }) => {
  const customLabelCol = column.find(item => item.customLabel);
  const displayLabel = customLabelCol ? customLabelCol.customLabel : column.length
  const selectedId = column.find(item => item.selectedId)?.selectedId

  return (
    <>
      {gridView === 'card' && def.isSecondaryCaption && column && <div className='dot-separator'>•</div>}
      <button
        className={classNames('', {
          [`viso-text-${color}`]: !!column?.length,
          [`viso-text-label`]: customLabelCol?.customLabel || column.length === 0
        })}
        onClick={(e) => {
          e.stopPropagation();
          if (!!column.length && !customLabelCol?.customLabel) {
            onClick({ _id: selectedId })
          }
        }}>
        {column && <span title={displayLabel}>{displayLabel} {prefix}</span>}
      </button>
    </>
  )
}

export default CountRenderer